import _ from 'lodash'
import io from 'socket.io-client'

import Vue from 'vue'

import store from '@/store'
import { subscription_object_collection } from '@/components/mixin.js'

// *****************************************************************************

let socket = io({ autoConnect: false, reconnection: false })

function on_socket_connected() {
  // console.log('on_socket_connected', socket.id)

  socket.sendBuffer = []
  store.commit('backend_connected')
  store.dispatch('init')
  // store.dispatch('restart_subscriptions')
  subscription_object_collection.restart_subscriptions()
}

function on_socket_reconnected() {
  // console.log('on_socket_reconnected', socket.id)
}

let current_reconnection_handler = undefined

function try_reconnection() {
  // console.log('try_reconnection', socket.id)
  current_reconnection_handler = undefined
  if (store.getters.user_is_authenticated & !store.state.backend_connected) {
    // console.log('trying reconnection')
    current_reconnection_handler = setTimeout(try_reconnection, 5000)
    socket.connect()
  } else {
    // console.log('skipping reconnection')
  }
}

function on_socket_disconnected() {
  // console.log('on_socket_disconnected', socket.id)

  store.commit('backend_disconnected')
  store.commit('empty_backend_objects')
  // Trying to reconnect if authentificated
  // TODO : Check if authentificated
  if (_.isUndefined(current_reconnection_handler)) {
    current_reconnection_handler = setTimeout(try_reconnection, 5000)
  }
}

function on_connect_error() {
  // console.log('on_connect_error', socket.id)
}

function on_connect_timeout() {
  // console.log('on_connect_timeout', socket.id)
}

socket.on('connect', on_socket_connected)
socket.on('reconnect', on_socket_reconnected)
socket.on('disconnect', on_socket_disconnected)

socket.on('connect_error', on_connect_error)
socket.on('connect_timeout', on_connect_timeout)

// *****************************************************************************

export { socket }
